<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4"> Purchase Requisition - #{{data.code}}</h4>
                <p class="text-subtitle-1">Displaing purchase requisition</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="my-1">
            <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_requisition.close) && data.state_code != stateClosed">
                <v-btn block class="primary" @click="closeRequisition" >
                    <v-icon left>mdi-check</v-icon>
                    Close Requisition
                </v-btn>
            </v-col>
            <v-col cols="12" md="3"  v-if="hasPermission(perm.purchase_requisition.update) && data.state_code != stateClosed" >
                <v-btn block depressed @click="handleEdit">
                    <v-icon left>mdi-pencil</v-icon>
                    edit
                </v-btn>
            </v-col>
            <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_requisition.delete) && data.state_code != stateClosed">
                <v-btn block depressed class="error--text" @click="handleRemove" :loading="removeLoading" >
                    <v-icon left>mdi-delete</v-icon>
                    delete
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchaseRequisition :value="data"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs v-model="tab">
                    <v-tab>Purchase Orders</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-row no-gutters v-if="data.state_code != stateClosed">
                            <v-col cols="12" md="3">
                                <v-btn depressed block @click="makeOrder" v-if="hasPermission(perm.purchase_order.create)">
                                    <v-icon left>mdi-gesture-tap-button</v-icon>
                                    make order
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-progress-linear indeterminate v-if="ordersLoading"/>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th>Code</th>
                                            <th>Date</th>
                                            <th>Supplier</th>
                                            <th>Created By</th>
                                            <th>State</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(d, i) in orders" :key="i" v-ripple @click="openOrder(d.id)">
                                            <td>
                                                <v-btn icon small>
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                                {{d.code}}
                                            </td>
                                            <td>{{d.date}}</td>
                                            <td>{{d.supplier}}</td>
                                            <td>{{d.created_by}}</td>
                                            <td>
                                                <PStatus :state="d.state"></PStatus>
                                            </td>
                                        </tr>
                                        <tr v-if="orders.length == 0">
                                            <td colspan="5" class="text-center">
                                                No Purchase Orders
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <LoadingOverlay v-model="loading"/>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchaseRequisition from'./../../../src/components/purchase/PurchaseRequisition';
import PAlert from './../../components/common/PAlert.vue'
import LoadingOverlay from './../../components/common/LoadingOverlay';
import { mapActions, mapGetters } from 'vuex';
import requisition from './../../services/purchase/requisition';
import OrderAPI from './../../services/purchase/order';
import PStatus from './../../components/common/PStatus.vue'

export default {
    name: 'RequisitionDisplayView',
    components: {
        PurchaseRequisition,
        LoadingOverlay,
        PAlert,
        PStatus
    },
    data() {
        return {
            id: null,
            loading: false,
            data: {},
            orders: [],
            ordersLoading: false,
            alert:{
                value: false,
                content: 'Are you sure?',
                callback: null
            },
            perm: permissions,
            stateClosed: 2,
            tab: 0,
            removeLoading: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/requisition/findByID",
            snackbar: "ui/snackbar/show",
            remove: "purchase/requisition/remove",
        }),
        fetchRequisition() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = {}
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handleRemove() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.removeAsync}
        },
        removeAsync() {
            this.removeLoading = true;
            this.remove(this.data).then(() => {
                this.$router.replace({name: "Requisitions"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.removeLoading = false;
            })
        },
        handleEdit() {
            this.$router.push({ name: "RequisitionEdit", params: { id: this.id } })
        },
        makeOrder(){
            this.$router.push({ name: "PurchaseOrderCreate", query: {
                requisition_id: this.id
            }})
        },
        closeRequisition() {
            this.alert = {...this.alert, value: true, callback: this.closeAsync}
        },
        closeAsync() {
            this.loading = true;
            requisition.close(this.data).then(() => {
                this.fetchRequisition();
                this.snackbar({color: "success", text: "Requisition Closed"});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false
            })
        },
        fetchOrders() {
            this.ordersLoading = true;
            OrderAPI.listByRequisition(this.id).then(response => {
                this.orders = response.data;
            }).finally(() => {
                this.ordersLoading = false
            });
        },
        openOrder(orderId) {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: orderId } })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetchRequisition();
        this.fetchOrders();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchRequisition();
        next()
    }
}
</script>

<style>

</style>